import { useMemo } from 'react'
import { useNavigate } from 'react-router'
import { useTypedTranslation } from '~/common/hooks/useTypedTranslation'
import { DossSignalType, useDossSignals } from '../../common/hooks/useDossSignals'
import { Button } from '../ui/atoms/button/Button'
import { Tooltip } from '../ui/atoms/tooltip/Tooltip'

export function SaveChartActions() {
  const navigate = useNavigate()
  const { t } = useTypedTranslation()
  const { dispatch, enableSaveButton } = useDossSignals()

  const tooltipTitle = useMemo(() => {
    return !enableSaveButton ? 'Add valid data settings to save your chart' : null
  }, [enableSaveButton])

  return (
    <div className="flex items-center justify-center gap-4">
      <Button onClick={() => navigate(-1)} variant="ghost">
        {t('common.actions.cancel')}
      </Button>
      <Tooltip placement="bottom-end" title={tooltipTitle}>
        {/* Tooltips only show on components with forwardRef, which is present on a native span element */}
        <span>
          <Button
            disabled={!enableSaveButton}
            onClick={() => dispatch(DossSignalType.SAVE_CHART_CLICKED)}
          >
            {t('common.actions.save')}
          </Button>
        </span>
      </Tooltip>
    </div>
  )
}
